"use strict";
/**
 * @enum OrderStatusUpdate
 * @description list of valid values that a custodian can use
 * to communicate the current status of a securities order;
 * note that OrderStatus is internal oms order status while
 * this OrderUpdateStatus is what comes from custodian
 * @link https://vestwell.atlassian.net/wiki/spaces/VW3/pages/3041427596/Order+Mgmt+-+Order+Status+Update
 */
exports.__esModule = true;
exports.OrderStatusUpdate = void 0;
var OrderStatusUpdate;
(function (OrderStatusUpdate) {
    OrderStatusUpdate["Accepted"] = "ACCEPTED";
    OrderStatusUpdate["CustodianError"] = "ERROR-CUSTODIAN";
    OrderStatusUpdate["Acknowledged"] = "ACKNOWLEDGED";
    OrderStatusUpdate["Rejected"] = "REJECTED";
    OrderStatusUpdate["Executed"] = "EXECUTED";
    OrderStatusUpdate["Reconfirm"] = "RECONFIRMED";
    OrderStatusUpdate["DestinationReject"] = "DESTINATION_REJECTED";
    OrderStatusUpdate["CustodianReject"] = "CUSTODIAN_REJECTED";
    OrderStatusUpdate["ExitReject"] = "EXIT_REJECTED";
    OrderStatusUpdate["Exited"] = "EXITED";
})(OrderStatusUpdate = exports.OrderStatusUpdate || (exports.OrderStatusUpdate = {}));
